import React from 'react'
import Image from 'next/image'
import Link from 'next/link'
import { Header2, Text } from '../../styles/Components'
import FoundersImage from '../../../public/about-us/founders.jpg'
import FoundersMobileImage from '../../../public/about-us/founders_mobile.jpg'
import { FoundersWrapper } from './styles'

const founders = [
  {
    id: 'gio',
    name: 'Giovanni Vaccaro',
    authorPath: '/author/giovanni-vaccaro',
    bio: (
      <>
        Gio, a top stylist formerly at{' '}
        <a
          href="https://www.fekkai.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="bio-link"
        >
          Fekkai
        </a>
        , has spent the last decade creating opportunities for beauty professionals to thrive at the highest level. With a deep passion for hospitality, Gio has played a key role in shaping Glamsquad into a brand celebrated for its elevated client experiences and strong, talented pro community.
      </>
    ),
  },
  {
    id: 'dave',
    name: 'David Goldweitz',
    bio: (
      <>
        Dave got his start with Glamsquad as an angel investor. He instantly
        knew that the merging of professional talent, brilliant tech, and
        top-tier service was a winning strategy. Today, he&rsquo;s the CEO and
        sees limitless potential for on-demand beauty. Connect with him on{' '}
        <a
          href="https://www.linkedin.com/in/davidgoldweitz/"
          target="_blank"
          rel="noopener noreferrer"
          className="bio-link"
        >
          LinkedIn
        </a>
        .
      </>
    ),
  },
]

const Founders = () => (
  <FoundersWrapper aria-label="Our founders">
    <Header2 className="founders-heading">Meet our founders</Header2>
    <Image
      className="founders-image-mobile"
      src={FoundersMobileImage}
      alt="Glamsquad co-founders Giovanni Vaccaro and CEO David Goldweitz in black-and-white studio portraits"
      sizes="100vw"
    />
    <div className="founders-grid">
      <div className="founders-column">
        {founders.map((f) => (
          <div className="founder-bio" key={f.id}>
            <Header2 fontSize={32} lineHeight="138%" className="founder-name">
              {f.authorPath
                ? <Link href={f.authorPath} className="founder-name-link">{f.name}</Link>
                : f.name}
            </Header2>
            <Text fontSize={22} lineHeight="1.36" spacing={0}>{f.bio}</Text>
          </div>
        ))}
      </div>
      <div className="founders-image-desktop">
        <Image
          src={FoundersImage}
          alt="Glamsquad co-founders Giovanni Vaccaro and CEO David Goldweitz in black-and-white studio portraits"
          fill
          style={{ objectFit: 'cover' }}
          sizes="(max-width: 1024px) 280px, 400px"
        />
      </div>
    </div>
  </FoundersWrapper>
)

export default Founders
